import { Action, Dispatch } from "@reduxjs/toolkit";
import { ColdexAPI } from "../../../apis/apiColdex/ColdexAPI";
import { IApiResult } from "../../../utils/interfaces/store/IApiResponse";
import { ColdexUserCompanyListModalSlice } from "./reducer";
import { CompanyXIndustryXColdex } from "../../../utils/types/CompanyXIndustryXColdex";
import { UserPartner } from "../../../utils/types/UserPartner";
import { PartnerEvaluated } from "../../../utils/types/PartnerEvaluated";

export const ColdexUserCompanyListModalEffect = {
  clean: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.clean());
    };
  },
  cleanNew: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.cleanNew());
    };
  },
  setSearch: (value: string = "") => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.setSearch(value));
    };
  },
  setPage: (value: number) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.setPage(value));
    };
  },
  setRowPerPage: (value: number) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.setRowPerPage(value));
    };
  },
  getCompaniesByColdex: (coldexId: number) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.getCompaniesByColdex());

      ColdexAPI.get<IApiResult<CompanyXIndustryXColdex[]>>(
        `adminColdex/CompanyXIndustryXColdex/Coldex/${coldexId}/company`
      )
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexError(
                {
                  iserror: true,
                  shorterror: data.shortMessage,
                  error: data.resultMessage,
                }
              )
            );
            return;
          }

          dispatch(
            ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexSuccess(
              data.resultObject
            )
          );
        })
        .catch((error) => {
          dispatch(
            ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
  getCompaniesByColdexAndUser: (coldexId: number, userId: number) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(
        ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexAndUser()
      );

      ColdexAPI.get<IApiResult<UserPartner[]>>(
        `adminColdex/coldex/${coldexId}/user/${userId}/partner`
      )
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexAndUserError(
                {
                  iserror: true,
                  shorterror: data.shortMessage,
                  error: data.resultMessage,
                }
              )
            );
            return;
          }

          dispatch(
            ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexAndUserSuccess(
              data.resultObject
            )
          );
        })
        .catch((error) => {
          dispatch(
            ColdexUserCompanyListModalSlice.actions.getCompaniesByColdexAndUserError(
              {
                iserror: true,
                shorterror: `Error short`,
                error,
              }
            )
          );
        });
    };
  },
  saveNewCompany: (
    coldexId: number,
    userId: number,
    partner: PartnerEvaluated
  ) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ColdexUserCompanyListModalSlice.actions.saveNewCompany());

      ColdexAPI.post<IApiResult<void>>(
        `adminColdex/coldex/${coldexId}/user/${userId}/partner`,
        {
          IDColdex: coldexId,
          idUser: userId,
          category: partner.code,
          partner: partner.ndoc,
        }
      )
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ColdexUserCompanyListModalSlice.actions.saveNewCompanyError({
                iserror: true,
                shorterror: data.shortMessage,
                error: data.resultMessage,
              })
            );
            return;
          }

          ColdexAPI.post<IApiResult<void>>(
            `adminColdex/SecurityxUserxColdex/${coldexId}?IdUser=${userId}`
          )
            .then(({ data }) => {
              if (data.dataError) {
                dispatch(
                  ColdexUserCompanyListModalSlice.actions.saveNewCompanyError({
                    iserror: true,
                    shorterror: data.shortMessage,
                    error: data.resultMessage,
                  })
                );
                return;
              }

              dispatch(
                ColdexUserCompanyListModalSlice.actions.saveNewCompanySuccess()
              );
            })
            .catch((error) => {
              dispatch(
                ColdexUserCompanyListModalSlice.actions.saveNewCompanyError({
                  iserror: true,
                  shorterror: `Error short`,
                  error,
                })
              );
            });
        })
        .catch((error) => {
          dispatch(
            ColdexUserCompanyListModalSlice.actions.saveNewCompanyError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
};
